import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Bar } from 'react-chartjs-2';
import { Header } from 'semantic-ui-react';

import { colors } from 'utils/colors';

export default class PensionIncomeBar extends Component {
  getChartData = (data) => {
    const validKeys = Object.keys(data).filter((key) => Number(key));

    return {
      labels: validKeys,
      datasets: [
        {
          label: 'CPP',
          stack: 'Dataset 1',
          backgroundColor: colors.blue,
          data: validKeys.map((key) => data[key].incCPP),
        },
        {
          label: 'OAS',
          stack: 'Dataset 1',
          backgroundColor: colors.orange,
          data: validKeys.map((key) => data[key].incOAS),
        },
        {
          label: 'GIS',
          stack: 'Dataset 1',
          backgroundColor: colors.red,
          data: validKeys.map((key) => data[key].incGIS),
        },
        {
          label: 'Employer Pension',
          stack: 'Dataset 1',
          backgroundColor: colors.teal,
          data: validKeys.map((key) => data[key].incPension),
        },
        {
          label: 'Other',
          stack: 'Dataset 1',
          backgroundColor: colors.darkBlue,
          data: validKeys.map((key) => data[key].incOther),
        },
      ],
    };
  };

  render() {
    const { data, size } = this.props;

    return (
      <div style={{ maxWidth: size, width: size, margin: '2rem auto' }}>
        <Bar data={this.getChartData(data)} options={barChartOptions} />
      </div>
    );
  }
}

PensionIncomeBar.propTypes = {
  data: PropTypes.object.isRequired,
  size: PropTypes.number.isRequired,
};

const barChartOptions = {
  tooltips: {
    callbacks: {
      label: (tooltipItems, dataItem) => {
        const { index, datasetIndex } = tooltipItems;
        return `${dataItem.datasets[datasetIndex].label}: $${dataItem.datasets[
          datasetIndex
        ].data[index].toLocaleString()}`;
      },
    },
  },
  scales: {
    yAxes: [
      {
        ticks: {
          callback: (value) => `$${value.toLocaleString()}`,
        },
      },
    ],
  },
};
